import { render, staticRenderFns } from "./SiftBEDate.vue?vue&type=template&id=0aca021c&scoped=true&"
import script from "./SiftBEDate.vue?vue&type=script&lang=js&"
export * from "./SiftBEDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca021c",
  null
  
)

export default component.exports